import styled from 'styled-components'

export const UploadWrapper = styled.div`
  margin-bottom: 2em;
`
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const Preview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 400px;
`

export const PreviewArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  margin: 10px;
  padding: 0px 2px 0px 2px;
  border: 1px dashed lightgrey;
  border-radius: 10px;
`

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/HeroDocument/components/UploadDocument/styles.js